import {authenticated_api} from "./base";

export const getCompanyDetail = async (stagedId) => {
  try {
    return await authenticated_api.get(`/company/?stagedId=${stagedId}`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const doesCompanyIdExist = async (stagedId) => {
  try {
    return await authenticated_api.post(`/company/id/?staged_id=${stagedId}`, {});
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const registerCompanyInquiry = async (stagedId) => {
  try {
    return await authenticated_api.post(`/company/inquiry/?staged_id=${stagedId}`, {});
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getRecentlyViewedCompanies = async () => {
  try {
    return await authenticated_api.get(`/company/viewed/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};